import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

const safetyModule: ModuleManifest = {
  id: 'P17',
  name: 'Safety',
  shortName: 'Safety',
  description: 'Workplace safety management, incident tracking, OSHA compliance, and insurance',
  icon: '🦺',
  status: 'live',
  urlPrefix: '/safety',
  routes,
  navItems,
  collections: {
    SAFETY_DOCUMENTS: 'safetyDocuments',
    SAFETY_INSURANCE: 'safetyInsurance',
    SAFETY_INCIDENTS: 'safetyIncidents',
  },
};

export default safetyModule;
